import React, { Component } from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Skeleton from '@material-ui/lab/Skeleton';
import api from './../../utilites/api';
import { setPedidoA } from './../../redux/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LisPedidos from './../../fragments/listPedidos';
import './pedidos.css';

class Pedidos extends Component {
  state = {
    pedidos: [],
    idUser: '',
    nomeUser: '',
    isLoading: false,
    colorHeader: "#991e25",
    endPadrao: ''
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    this.getServidor()
  }

  async getServidor() {
    try {

      const {
        setPedidoA
      } = this.props;



      // Pega o ID do usuário do localStorage
      const userId = localStorage.getItem('@webApp/userid');
      
      // Usa o novo endpoint com parâmetro GET
      const response = await api.get(`ws/api_historico_pedidos.php?busca=${userId}`);
      
      // Mantém a segunda requisição se necessário
      const data = new FormData();
      data.append('cliente', userId + '-' + localStorage.getItem('@webApp/username'));
      const response2 = await api.post('ws/PedidoAberto1.php', data);
      
      console.log("resposta historico ", response.data);
      console.log("resposta pedido aberto ", response2.data);

      setPedidoA("0");

      if (response.status === 200 && response.data) {
        // Processa os dados da API para garantir a estrutura correta
        let pedidosProcessados = [];
        
        if (Array.isArray(response.data)) {
          pedidosProcessados = response.data.map(pedido => {
            // Processa os itens do pedido
            let itensProcessados = [];
            if (pedido.itens && Array.isArray(pedido.itens)) {
              itensProcessados = pedido.itens.map(item => {
                // Verifica diferentes formas do campo adicionais (incluindo erro de digitação)
                let adicionais = item.adicionais || item.adcionais || item.Adicionais;
                
                if (adicionais === null || adicionais === undefined || adicionais === 'null') {
                  adicionais = null;
                } else if (typeof adicionais === 'string' && adicionais.trim() === '') {
                  adicionais = null;
                }
                
                return {
                  Produto: item.produto || 'Produto não informado',
                  Quantidade: item.quantidade || '1',
                  Valor: item.valor || '0.00',
                  Adicionais: adicionais
                };
              });
            }
            
            return {
              Data: pedido.data_emissao ? pedido.data_emissao.split(' ')[0] : new Date().toLocaleDateString('pt-BR'),
              Valor: pedido.valor || "0.00",
              Status: pedido.status || "Pendente",
              Itens: itensProcessados,
              FormaPagamento: pedido.tipo_pagamento || 'Não informado',
              Endereco: pedido.endereco,
              TaxaEntrega: pedido.taxa_entrega || "0.00",
              Subtotal: pedido.subtotal || "0.00"
            };
          });
        } else if (response.data.length !== undefined) {
          // Se não é array mas tem length, tenta converter
          pedidosProcessados = Object.values(response.data).map(pedido => {
            // Processa os itens do pedido
            let itensProcessados = [];
            if (pedido.itens && Array.isArray(pedido.itens)) {
              itensProcessados = pedido.itens.map(item => {
                // Verifica diferentes formas do campo adicionais (incluindo erro de digitação)
                let adicionais = item.adicionais || item.adcionais || item.Adicionais;
                
                if (adicionais === null || adicionais === undefined || adicionais === 'null') {
                  adicionais = null;
                } else if (typeof adicionais === 'string' && adicionais.trim() === '') {
                  adicionais = null;
                }
                
                return {
                  Produto: item.produto || 'Produto não informado',
                  Quantidade: item.quantidade || '1',
                  Valor: item.valor || '0.00',
                  Adicionais: adicionais
                };
              });
            }
            
            return {
              Data: pedido.data_emissao ? pedido.data_emissao.split(' ')[0] : new Date().toLocaleDateString('pt-BR'),
              Valor: pedido.valor || "0.00",
              Status: pedido.status || "Pendente",
              Itens: itensProcessados,
              FormaPagamento: pedido.tipo_pagamento || 'Não informado',
              Endereco: pedido.endereco,
              TaxaEntrega: pedido.taxa_entrega || "0.00",
              Subtotal: pedido.subtotal || "0.00"
            };
          });
        }
        
        this.setState({
          pedidos: pedidosProcessados
        });
        console.log("Pedidos processados:", pedidosProcessados);
      } else {
        // Dados de exemplo para demonstração (remover em produção)
        const dadosExemplo = [
          {
            Data: "11/07/2025",
            Valor: "82.00",
            Status: "Pedido aceito (59466)",
            FormaPagamento: "PIX",
            Endereco: "rua, 1, 15 - CURADO 2ª",
            TaxaEntrega: "5.00",
            Subtotal: "77.00",
            Itens: [
              { 
                Produto: "MONTE SUA PIZZA", 
                Quantidade: "1", 
                Valor: "59",
                Adicionais: "(Sabores: ATUM, BACON, ) (Borda: CREME CHEESSE, )"
              },
              { 
                Produto: "COCA COLA 2 LITROS", 
                Quantidade: "1", 
                Valor: "18",
                Adicionais: null
              }
            ]
          }
        ];
        this.setState({
          pedidos: dadosExemplo
        });
      }

    } catch (error) {
      console.log('Erro ao buscar pedidos:', error);
      console.log('Detalhes do erro:', error.response?.data || error.message);
      
      // Em caso de erro, usa dados de exemplo
      const dadosExemplo = [
        {
          Data: "11/07/2025",
          Valor: "82.00",
          Status: "Pedido aceito (59466)", 
          FormaPagamento: "PIX",
          Endereco: "rua, 1, 15 - CURADO 2ª",
          TaxaEntrega: "5.00",
          Subtotal: "77.00",
          Itens: [
            { 
              Produto: "MONTE SUA PIZZA", 
              Quantidade: "1", 
              Valor: "59",
              Adicionais: "(Sabores: ATUM, BACON, ) (Borda: CREME CHEESSE, )"
            },
            { 
              Produto: "COCA COLA 2 LITROS", 
              Quantidade: "1", 
              Valor: "18",
              Adicionais: null
            }
          ]
        }
      ];
      
      this.setState({
        pedidos: dadosExemplo
      });
      
      alert('Erro na comunicação com servidor! Exibindo dados de exemplo.');
    }

    this.setState({ isLoading: false });
  }

  form() {
    return (
      <div style={styles.container} className="pedidos-container">
        {this.header()}
        <div style={styles.content}>
          {this.state.pedidos.length > 0 ? (
            <div>
              <div style={styles.titleSection}>
                <h2 style={styles.pageTitle}>Seus Pedidos</h2>
                <p style={styles.pageSubtitle}>
                  Acompanhe o status dos seus pedidos
                </p>
              </div>
              {this.state.pedidos.map((pedido, index) => (
                <LisPedidos 
                  key={index}
                  Data={pedido.Data} 
                  Valor={pedido.Valor} 
                  Status={pedido.Status} 
                  Itens={pedido.Itens}
                  FormaPagamento={pedido.FormaPagamento}
                  Endereco={pedido.Endereco}
                  TaxaEntrega={pedido.TaxaEntrega}
                  Subtotal={pedido.Subtotal}
                />
              ))}
            </div>
          ) : (
            <div style={styles.emptyState}>
              <div style={styles.emptyIcon}>📋</div>
              <h3 style={styles.emptyTitle}>Nenhum pedido encontrado</h3>
              <p style={styles.emptySubtitle}>
                Você ainda não fez nenhum pedido. Que tal dar uma olhada no nosso cardápio?
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }

  enderecoS() {
    return (
      <div style={styles.container} className="pedidos-container">
        {this.header()}
        <div style={styles.content}>
          <div style={styles.titleSection}>
            <h2 style={styles.pageTitle}>Carregando pedidos...</h2>
          </div>
          <Skeleton 
            variant="rect" 
            height={80} 
            style={{ 
              marginBottom: 15, 
              borderRadius: 12 
            }} 
            className="skeleton-loading" 
          />
          <Skeleton 
            variant="rect" 
            height={80} 
            style={{ 
              marginBottom: 15, 
              borderRadius: 12 
            }} 
            className="skeleton-loading" 
          />
          <Skeleton 
            variant="rect" 
            height={80} 
            style={{ 
              marginBottom: 15, 
              borderRadius: 12 
            }} 
            className="skeleton-loading" 
          />
          <Skeleton 
            variant="rect" 
            height={80} 
            style={{ 
              marginBottom: 15, 
              borderRadius: 12 
            }} 
            className="skeleton-loading" 
          />
          <Skeleton 
            variant="rect" 
            height={80} 
            style={{ 
              marginBottom: 15, 
              borderRadius: 12 
            }} 
            className="skeleton-loading" 
          />
        </div>
      </div>
    );
  }

  header() {
    return (
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <button style={styles.backButton} onClick={() => {
            this.props.history.goBack()
          }}>
            <ArrowBackIcon style={{ color: '#fff' }} />
          </button>
          <div style={styles.headerTitle}>
            <label style={styles.titleText}>Pedidos</label>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return this.state.isLoading ? this.enderecoS() : this.form();
  }
}

const mapStateToProps = store => ({
  pedidoA: store.PedidoAReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setPedidoA }, dispatch);

const styles = {
  container: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    paddingTop: '60px' // Adiciona espaço para o header fixo
  },
  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    marginTop: 0,
    display: 'flex',
    justifyContent: 'space-between',
    height: 60,
    paddingLeft: 0,
    paddingRight: 15,
    backgroundColor: '#991e25',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  headerContent: {
    marginLeft: 15,
    marginTop: 13,
    display: 'flex',
    alignItems: 'center'
  },
  backButton: {
    height: 48,
    width: 48,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    transition: 'background-color 0.3s ease'
  },
  headerTitle: {
    height: 48,
    display: 'flex',
    alignItems: 'center',
    marginLeft: 10
  },
  titleText: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#fff'
  },
  content: {
    padding: '20px 16px'
  },
  titleSection: {
    marginBottom: 24,
    textAlign: 'center'
  },
  pageTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
    margin: '0 0 8px 0'
  },
  pageSubtitle: {
    fontSize: 16,
    color: '#666',
    margin: 0
  },
  emptyState: {
    textAlign: 'center',
    padding: '60px 20px',
    backgroundColor: '#ffffff',
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  },
  emptyIcon: {
    fontSize: 64,
    marginBottom: 16
  },
  emptyTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 8
  },
  emptySubtitle: {
    fontSize: 14,
    color: '#666',
    lineHeight: 1.5
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pedidos);
